module.exports = __webpack_public_path__ + "static/media/preferences.c505afc2.svg";